<template>
  <b-modal :id="id" title="Sichtbare Spalten wählen" body-class="p-0" @ok="$emit('ok')">
    <b-list-group style="max-height: calc(100svh - 250px); overflow-y: auto">
      <b-list-group-item
        class="border-top-0 border-left-0 border-right-0"
        v-for="item in fields.filter(x => x.hideable && x.label !== '')"
        :key="item.key"
      >
        <b-form-checkbox
          v-model="item.visible"
          :value="true"
          :unchecked-value="false"
          @update="AppState.updateVisibleFields(id, fields)"
        >
          {{ item.label }}
        </b-form-checkbox>
      </b-list-group-item>
    </b-list-group>
    <template #modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="light" class="mr-auto" @click="resetColumnWidths">
        Spaltenbreiten zurücksetzen
      </b-button>
      <b-button size="sm" variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button size="sm" variant="primary" @click="ok()">OK</b-button>
    </template>
  </b-modal>
</template>

<script>
import AppState from '@/store/App.js';
import { RESET_EVENT } from '@/directives/resizableColumns.mjs';
export default {
  data() {
    return {
      AppState
    };
  },
  props: {
    fields: {
      type: Array
    },
    id: {
      type: String
    },
    // Key the resizable-columns directive persists widths under. Defaults to `id`
    // for views where the modal id already equals the table's storageKey.
    storageKey: {
      type: String,
      default: null
    }
  },
  methods: {
    resetColumnWidths() {
      document.dispatchEvent(new CustomEvent(RESET_EVENT, { detail: this.storageKey || this.id }));
    }
  }
};
</script>

<style></style>
